// Handles expand-on-click behavior for shared content extender patterns.
const contentTriggers = document.querySelectorAll('.contentExtender-trigger[aria-controls]');

contentTriggers.forEach(trigger => {
    trigger.addEventListener('click', event => {
        const currentTrigger = event.currentTarget;
        const controlledContent = document.getElementById(currentTrigger.getAttribute('aria-controls'));

        if (!controlledContent) {
            return;
        }

        const hiddenContent = controlledContent.hidden
            ? [controlledContent]
            : controlledContent.querySelectorAll('.contentExtender-item--hide[hidden]');

        if (hiddenContent.length === 0) {
            return;
        }

        hiddenContent.forEach(item => {
            item.hidden = false;
        });

        currentTrigger.setAttribute('aria-expanded', 'true');

        const focusableElementSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
        let firstFocusableElement;

        hiddenContent.forEach(item => {
            firstFocusableElement ??= item.querySelector(focusableElementSelector);
        });

        const triggerAction = currentTrigger.closest('.contentExtender-action--expand');
        const hideTrigger = () => {
            if (triggerAction) {
                triggerAction.hidden = true;
            } else {
                currentTrigger.hidden = true;
            }
        };

        if (firstFocusableElement) {
            window.requestAnimationFrame(() => {
                firstFocusableElement.focus();
                hideTrigger();
            });
        } else {
            hideTrigger();
        }
    });
});
